import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Globals } from '../../globals';
import { PendingRequest } from '../modal/pendingrequest';
import { PromoCode } from '../modal/promocode';


@Injectable({
    providedIn: 'root'
})

export class PromoCodeService {
    constructor(private httpclient: HttpClient, private global: Globals) {
    }
    checkPromCode(promocode, userId) {
        let headers: HttpHeaders = new HttpHeaders();
        headers = headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.get(this.global.G_apiUrl + "/checkPromoCode/" + promocode.promoCodeName + "/" + userId, { headers: headers });
    }
    checkPromCodeCampRegister(promocode) {
        let headers: HttpHeaders = new HttpHeaders();
        headers = headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.get<PromoCode>(this.global.G_apiUrl + "/checkPromoCode/" + promocode , { headers: headers });
    }
}